import { useParams, useNavigate } from 'react-router-dom';
import JobReportDialog from '../../../components/contractor/job-execution/JobReportDialog';

/**
 * ContractorJobExecution Page
 *
 * This page renders the JobReportDialog for the given job instance.
 * When the dialog is closed, it navigates back to the contractor dashboard.
 */
export default function ContractorJobExecution() {
  const { instanceId } = useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/contractor/today-jobs');
  };

  if (!instanceId) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="bg-red-500/10 border border-red-500 rounded-lg p-6 max-w-md text-center">
          <h2 className="text-red-400 text-xl font-bold mb-2">Error</h2>
          <p className="text-red-300">No job instance ID provided</p>
          <button
            onClick={() => navigate('/contractor/today-jobs')}
            className="mt-4 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <JobReportDialog
        instanceId={instanceId}
        onClose={handleClose}
      />
    </div>
  );
}
